import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { r } from '@angular/core/src/render3';

declare var $: any

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  TokenID: any;
  Token: any;

  submitted = false
  newPass = ""
  confirmPass = ""

  validToken = false

  constructor(
    private util: UtilService,
    private api: ApiService,
    private Route: ActivatedRoute,
    private router: Router
  ) { }

  async ngOnInit() {
    this.Route.queryParams.subscribe((Params: any) => {
      this.TokenID = Params["id"];
    });

    this.util.ShowWaiting(true);
    if (this.TokenID == null || this.TokenID == "") {
      $("#btnMainConfirm").off('click');

      let thisTs = this;
      $("#btnMainError").click(async function () {
        thisTs.router.navigate(["/mainmenu/index"])
      });

      this.util.ErrorDialog("Invalid token.");
      $("#btnSave").attr("disabled", "disabled");
    }
    else {
      this.Token = await this.GetToken();
      if (this.Token == null || this.Token.trim() == "") {
        $("#btnMainConfirm").off('click');

        let thisTs = this;
        $("#btnMainError").click(async function () {
          thisTs.router.navigate(["/mainmenu/index"])
        });

        this.util.ErrorDialog("Invalid token.");
        $("#btnSave").attr("disabled", "disabled");
      }
      else {
        this.validToken = true
        //this.DeleteToken(this.TokenID);
      }
    }
    this.util.ShowWaiting(false);
  }


  async resetPassword() {
    this.submitted = true
    if (this.newPass.length > 0 && this.newPass == this.confirmPass && this.validToken
      && this.passwordValidation()) {
      this.util.ShowWaiting(true);
      let ParamObj: any = {
        //username: (this.Token != null && this.Token.username != null) ? this.Token.username : '',
        newpassword: this.newPass,
        token_id: this.Token
      };
      try {
        let thisTs = this
        let Res: any = await this.api.postCustomApi("user", "resetpassword", ParamObj);
        //let tmp :any = await this.util.AesDecryptDictValue(Res.json())
        if (Res.code == "200") {
          this.util.ShowWaiting(false);
          this.util.SuccessDialog("เปลี่ยนรหัสผ่านสำเร็จ");
          $('#btnSuccessOK').on('click', function(){
            thisTs.router.navigate(["mainmenu/login"])
          });
        }
        else {
          this.util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
        }
      }
      catch (err) {
        console.log(err);
        this.util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
      }
      this.util.ShowWaiting(false);
    }
    else{

    }
  }

  async GetToken() {
    let Res: any = await this.api.getCustomAPI("User", "GetToken", "token_id=" + this.TokenID);
    if (Res != null) {
      return Res.token_id
    }
    return Res;
  }

  async DeleteToken(TokenID: any) {
    let ParamObj: any = {
      token_id: TokenID
    };
    await this.api.postCustomApi("user", "deletetoken", ParamObj);
  }

  passwordValidation() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass)
  }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts